module.exports = __webpack_public_path__ + "static/media/kettlebell.9b80f401.webp";